import type { Account } from './account';
import type { ClientGroup } from './clientGroup';
import type { CustomFieldValue } from './customField';
import type { Organization } from './organization';
import type { TranslatedString } from './shared';
import type { Statistics } from './stats';
import type { User } from './user';

export enum AccountGroupStates {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum AccountGroupTypes {
  INDIVIDUAL = 'INDIVIDUAL',
  NON_INDIVIDUAL = 'NON_INDIVIDUAL',
  HOUSEHOLD = 'HOUSEHOLD',
  ORGANIZATION = 'ORGANIZATION',
}

export type AccountGroup = {
  id: string;
  user?: User;
  accounts: Account[];
  hasFullAccess?: boolean;
  translatedName: TranslatedString;
  statistics?: Statistics;
  type: AccountGroupTypes;
  state: AccountGroupStates;
  householdClientGroup?: ClientGroup;
  lastUpdatedBy?: string;
  organization: Organization;
  customFields?: CustomFieldValue[];
};
